import { useEffect, useState } from "react"
import DataSetComp from "./DataSetComp"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import {
  createMappingAsync,
  // createMappingAsync,
  getDatasetList,
  getScenarioList,
  setScenarioMappingStatus,
} from "./HarmonizationSlice"
import { Box, Button } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom"
import { API_STATUS, SCREENS_DETAILS } from "../../util/StaticData"
import Swal from "sweetalert2"
import MappingWarningModal from "../../components/Harmonization/MappingWarningModal"
import MappingSummary from "./dataset/MappingSummary"
import { getScenarioDetails } from "./HarmonizationSlice"
import { setShowMappingSummary } from "./mapping/MapSlice"
// import { API_STATUS } from "../../util/StaticData"

const convertToString = (arr: string[]) => {
  const columns = arr.reduce(
    (acc, curr, index) => `${acc}${index !== 0 ? "," : ""}${curr}`,
    "",
  )
  return columns
}

const MappingComp = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { id } = useParams()
  const {
    scenarioList,
    datasetList,
    dataset1,
    dataset2,
    scenarioMappingStatus,
  } = useAppSelector((state) => state.harmonization)
  const { showMappingSummary } = useAppSelector((state) => state.map)
  const [mapPopUpOpen, setMapPopUpOpen] = useState(false)
  const [isDuplicateMapping, setIsDuplicateMapping] = useState(false)
  const user = useAppSelector((state) => state.harmonization.user)

  useEffect(() => {
    if (datasetList.length === 0) dispatch(getDatasetList())
  }, [datasetList, dispatch])

  useEffect(() => {
    if (scenarioList.length === 0) dispatch(getScenarioList())
  }, [dispatch])

  useEffect(() => {
    if (id) {
      const numericId = Number(id)
      if (!Number.isNaN(numericId)) {
        console.log("[MappingComp] Detected route id:", numericId)
        console.log("[MappingComp] Dispatching getScenarioDetails...")
        dispatch(getScenarioDetails({ id: numericId }))
      }
    }
  }, [id, dispatch])

  useEffect(() => {
    console.log("[MappingComp] scenarioMappingStatus:", scenarioMappingStatus)
    console.log("[MappingComp] dataset1.selectedDataset:", dataset1.selectedDataset)
    console.log("[MappingComp] dataset2.selectedDataset:", dataset2.selectedDataset)
    console.log("[MappingComp] dataset1.selectedColumns:", dataset1.selectedColumns)
    console.log("[MappingComp] dataset2.selectedColumns:", dataset2.selectedColumns)
  }, [scenarioMappingStatus, dataset1.selectedDataset, dataset2.selectedDataset, dataset1.selectedColumns, dataset2.selectedColumns])

  const mappedDataLen = useAppSelector((state) => state.map.mappedData.length)
  const showSummary = useAppSelector((state) => state.map.showMappingSummary)
  useEffect(() => {
    console.log("[MappingComp] mappedData length:", mappedDataLen)
    console.log("[MappingComp] showMappingSummary:", showSummary)
  }, [mappedDataLen, showSummary])

  const triggerMapping = () => {
    if (scenarioList.length > 0) {
      scenarioList.forEach((scenario) => {
        const dataSetMatched =
          dataset1.selectedDataset === scenario.sourceDataset &&
          dataset2.selectedDataset === scenario.targetDataset
        const columnsMatched =
          dataset1.selectedColumns.length === scenario.sourceColumns.length &&
          dataset1.selectedColumns.every(
            (value, index) => value === scenario.sourceColumns[index],
          )

        if (dataSetMatched && columnsMatched) {
          setIsDuplicateMapping(true)
        }
      })
    }
    setMapPopUpOpen(true)
  }

  const handleWarningModalAction = (action: string) => {
    setIsDuplicateMapping(false)
    setMapPopUpOpen(false)
    if (action === "proceed") {
      const payload = {
        source_dataset: dataset1.selectedDataset,
        source_columns: convertToString(dataset1.selectedColumns),
        target_dataset: dataset2.selectedDataset,
        target_columns: convertToString(dataset2.selectedColumns),
        created_by: user,
      }
      console.log("handleWarningModalAction", payload)
      dispatch(createMappingAsync({ payload })).then(() => {
        if (scenarioMappingStatus === API_STATUS.FAILED) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Data Mapping Failed",
          })
        }
        else {
          // navigate("/" + SCREENS_DETAILS.DATA_HARMONIZATION)
           dispatch(setShowMappingSummary(true))
        }
      })
    } else if (action === "home") {
      navigate("/" + SCREENS_DETAILS.DATA_HARMONIZATION)
    }
    // if (action === "proceed") {
    //   dispatch(setScenarioMappingStatus(API_STATUS.LOADING))
    //   setTimeout(() => {
    //     dispatch(setScenarioMappingStatus(API_STATUS.IDLE))
    //     dispatch(setShowMappingSummary(true))
    //   }, 2000)
    // }
  }

  const mapButtonClick = () => {
    // dispatch(setScenarioMappingStatus(API_STATUS.LOADING))
    triggerMapping()
    // setTimeout(() => {
    //   dispatch(setScenarioMappingStatus(API_STATUS.IDLE))
    //   dispatch(setShowMappingSummary(true))
    // }, 2000)
  }

  return (
    <Box className="flex-1 grid grid-cols-1 gap-4 overflow-x-auto">
      <div className="flex flex-col gap-4 w-full grow">
        <div className="flex justify-between items-center">
          <p className="text-[18px] font-bold">AI Enabled Harmonization</p>
        </div>

        <div className="flex flex-col rounded-md bg-background-white p-4 px-6">
          <div className="flex gap-4">
            <DataSetComp id={1} title="Primary Dataset" />
            <DataSetComp id={2} title="Secondary Dataset" />
          </div>

          <Button
            style={{
              background:
                "linear-gradient(90deg, #67F0FF 0%, #CCC0DD 50%, #FFA0BB 100%)",
              width: "fit-content",
              alignSelf: "end",
            }}
            sx={{
              fontWeight: 700,
              fontSize: 12,
              color: "#333333",
              textTransform: "none",
              px: 3,
              borderRadius: "4px",
              transition: "all 0.3s ease",
              "&:hover": {
                background:
                  "linear-gradient(90deg, #FFA0BB 0%, #CCC0DD 50%, #67F0FF 100%)",
                transform: "scale(1.02)",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              },
            }}
            onClick={mapButtonClick}
            disabled={
              dataset1.selectedColumns.length === 0 ||
              dataset2.selectedColumns.length === 0
            }
          >
            Use GenAI for Mapping
          </Button>
        </div>

        {showMappingSummary && (
          <div className="flex flex-col rounded-md bg-background-white p-4 px-6">
            <MappingSummary />
          </div>
        )}

        <MappingWarningModal
          isDuplicateMapping={isDuplicateMapping}
          isOpen={mapPopUpOpen}
          onClick={handleWarningModalAction}
        />
      </div>
    </Box>
  )
}

export default MappingComp
